import { put } from 'redux-saga/effects';
import { closeModal } from 'lib/ui/Modal';

import { DICT_EDITOR_MODAL } from './config';

export const closeDictEditor = function* () {
  yield put(closeModal(DICT_EDITOR_MODAL));
};
